import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

@Component({
    selector: 'app-tga-potato-seed-starch-dashboard',
    template: `
    <agr-powerbi-report [workspaceId]="workspaceId" [reportId]="reportId"/>`,
    imports: [PowerbiReportComponent],
})
export class TgaPotatoSeedStarchDashboardComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.TGA_POTATO_SEED_STARCH_DASHBOARD_WORKSPACE_ID;
    this.reportId = this.env.TGA_POTATO_SEED_STARCH_DASHBOARD_REPORT_ID;
  }
}
